import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, PlusSquare, Image, Settings } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const MobileNavigation = () => {
  const location = useLocation();
  const { isDark } = useTheme();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className={`md:hidden fixed bottom-0 left-0 right-0 ${
      isDark ? 'bg-black border-t border-zinc-800' : 'bg-white border-t border-zinc-200'
    } py-2 px-4 z-50`}>
      <div className="flex items-center justify-around">
        <Link
          to="/"
          className={`flex flex-col items-center gap-1 ${
            isActive('/') 
              ? isDark ? 'text-white' : 'text-zinc-900'
              : isDark ? 'text-zinc-400' : 'text-zinc-500'
          }`}
        >
          <Home className="w-5 h-5" />
          <span className="text-xs">Home</span>
        </Link>

        <Link
          to="/create"
          className={`flex flex-col items-center gap-1 ${
            isActive('/create') 
              ? isDark ? 'text-white' : 'text-zinc-900'
              : isDark ? 'text-zinc-400' : 'text-zinc-500'
          }`}
        >
          <PlusSquare className="w-5 h-5" />
          <span className="text-xs">Create</span>
        </Link>

        <Link
          to="/mediatheque"
          className={`flex flex-col items-center gap-1 ${
            isActive('/mediatheque') 
              ? isDark ? 'text-white' : 'text-zinc-900'
              : isDark ? 'text-zinc-400' : 'text-zinc-500'
          }`}
        >
          <Image className="w-5 h-5" />
          <span className="text-xs">Library</span>
        </Link>

        <Link
          to="/settings"
          className={`flex flex-col items-center gap-1 ${
            isActive('/settings') 
              ? isDark ? 'text-white' : 'text-zinc-900'
              : isDark ? 'text-zinc-400' : 'text-zinc-500'
          }`}
        >
          <Settings className="w-5 h-5" />
          <span className="text-xs">Settings</span>
        </Link>
      </div>
    </nav>
  );
};

export default MobileNavigation;